module.exports = __webpack_public_path__ + "static/media/pk.f7d819b7.svg";